module.exports = window.Caboodal = window.Caboodal || {};
